"use client";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogFooter,
  AlertDialogCancel,
} from "@/components/ui/alert-dialog";
import { PricingSection } from "./PricingSection";
import { useTranslation } from "react-i18next";


export interface RateLimitDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  monthlyLimit: number | null;
  currentTier?: string;
}

export function RateLimitDialog({
  open,
  onOpenChange,
  monthlyLimit,
  currentTier,
}: RateLimitDialogProps) {
  const { t } = useTranslation();

  const limitText =
    monthlyLimit !== null
      ? monthlyLimit.toLocaleString()
      : t("rate_limit.unknown_limit", "your plan's");

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-2xl text-center md:text-3xl">
            {t("rate_limit.dialog_title", "You've reached your monthly limit")}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-base text-center md:text-lg text-neutral-300">
            {t(
              "rate_limit.dialog_description",
              `You've reached your monthly limit of ${limitText} messages. Upgrade your plan to continue using Lema.`
            ).replace("${limitText}", limitText)}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="mt-6">
          <PricingSection compact={true} />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {t("rate_limit.close", "Close")}
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

